import React, { useEffect, useState } from "react";
import { ReactComponent as LocationIcon } from "assets/icons/location.svg";
import useProperties from "hooks/useProperties";
import { formatCurrency } from "utils/formatNumber";
import useAuth from "hooks/useAuth";
import AnimatedDialogLayout from "components/Dialog/AnimatedDialogLayout";
import PaginatedPropertiesPopup from "./PaginatedPropertiesPopup";
import SearchCard from "components/Card/SearchCard";
import PropertyPopup from "components/Dialog/PropertyPopup";

const BestPriceM2Properties = () => {
  const initialDisplayCount = 3; // Initally 3 property will display
  const {
    getLowestPricePerSquareMeterProperty,
    isFetchingLowestPricePerSqm,
    lowestPricePerSqmProperties,
    setSelectedPropertyPopup,
    selectedPropertyPopup,
    togglePaginatedPropertyPopup,
  } = useProperties();
  const { user } = useAuth();

  useEffect(() => {
    getLowestPricePerSquareMeterProperty();
  }, [user]);

  const handleOpenPaginatedPropertyPopup = () => {
    document.body.style.overflow = "hidden";
    togglePaginatedPropertyPopup("bestPriceM2");
  };

  const displayedProperties = lowestPricePerSqmProperties.slice(
    0,
    initialDisplayCount
  );

  return (
    <>
      <div className="bg-white rounded-[15px] pt-[18px] px-[15px] pb-[15px] w-full">
        <h1 className="text-[22px] leading-[30px] font-semibold text-black">
          Scopri le proprietà con il{" "}
          <span className="text-[#197D00]">miglior</span> prezzo/mq per te.
        </h1>
        <div className="mt-[17px] flex flex-col gap-y-4">
          {displayedProperties.length > 0 &&
            displayedProperties?.map((property, index) => (
              <div
                key={property?._id}
                onClick={() =>
                  setSelectedPropertyPopup({
                    property,
                    id: "bestPriceM2Property",
                  })
                }
                className="h-[216px] md:h-[250px] sm:h-[316px] lg:h-[316px] 2xl:h-[216px] w-full"
              >
                <img
                  src={property?.pictures[0]}
                  alt="property"
                  className="rounded-[5px] h-[150px] md:h-[184px] sm:h-[250px] lg:h-[250px] 2xl:h-[150px] w-full object-cover"
                />
                <div className="flex items-start justify-between mt-3">
                  <div className="w-[45%]">
                    <h1 className="text-black text-[15px] truncate font-medium leading-[26px]">
                      {property?.title}
                    </h1>
                    <div className="flex items-center space-x-1 h-5">
                      <LocationIcon className="text-black" />
                      <p className="text-black text-[12px] font-normal">
                        {property?.location?.name}
                      </p>
                    </div>
                  </div>
                  <div className="pl-2">
                    <h4 className="font-bold flex-shrink-0 text-[22px] text-black leading-[22px]">
                      {formatCurrency(
                        property.sale_price,
                        property?.sale_currency
                      )}
                    </h4>
                    <button className="rounded-[5px] flex-shrink-0 bg-[#33773117] h-[27px] px-[9px] mt-[5px] ">
                      <p className="text-[#197D00] text-[16px] truncate w-full line-clamp-1 whitespace-normal">
                        <span className="font-semibold">
                          {formatCurrency(
                            property.pricePerSquareMeter,
                            property?.sale_currency
                          )}
                        </span>{" "}
                        per metro quadro
                      </p>
                    </button>
                  </div>
                </div>
              </div>
            ))}
        </div>
        {displayedProperties.length > 2 && (
          <button
            onClick={handleOpenPaginatedPropertyPopup}
            className="bg-primary w-full mt-4 h-[60px] rounded-[10px] text-white text-center text-[15px] font-medium underline"
          >
            Mostra Lista Completa
          </button>
        )}
      </div>
      <PaginatedPropertiesPopup
        properties={lowestPricePerSqmProperties}
        id="bestPriceM2"
      />
      {/* Property card on click mini cell*/}
      <PropertyPopup popupType="bestPriceM2Property" isOrganisePage={true} />
    </>
  );
};

export default BestPriceM2Properties;
